export default __webpack_public_path__ + "static/media/mexico-flag.9252e0f3.png";